(function ($) {
    $(() => {

        $('.js-more-news').on('click', function () {

            $('.js-loader').removeClass('hide');
            $('.js-more-news').hide();
            setTimeout(function () {
                let post_ids = [];
                $('.js-news-card').each(function (index) {
                    post_ids.push($(this).data('id'));
                });

                var data = {
                    action: 'more_news',
                    post_ids: post_ids,
                };

                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: data,
                    success(res) {

                        $('.js-news-wrapper').append(res.data.return_posts);
                        $('.js-loader').addClass('hide');
                        $('.js-more-news').show();
                        $(document).ready(function () {
                            $('.match-h').matchHeight({
                                byRow: true,
                                property: 'height',
                                target: null,
                                remove: false
                            });
                        });

                        if (res.data.count === 0) {
                            $('.js-more-news').remove();
                            $('.js-loader').remove();
                        }
                    }
                }).done(response => {

                });
            }, 500);
        });

        if($('.js-futureal-news-wrapper').length > 0) {

            var data = {
                action: 'get_news',
            };

            $.ajax({
                type: 'POST',
                url: 'https://www.futurealgroup.com/wp-admin/admin-ajax.php?lang=en',
                data: data,
                success: function (res) {
                    var objkeys = $.parseJSON(res);
                    $.each(objkeys, function (key, value) {

                        $('.js-futureal-news-wrapper').append(
                            `
                            <div class="col-lg-3">
                                <div class="news-card-detailed position-relative card-hover">
                                    <a class="link-a" href="${value.permalink}"></a>
                                    <div class="news-card-detailed__image background-image" style="background-image: url('${value.thumbnail}')">

                                    </div>
                                    <div class="news-card-detailed__text">
                                        <div class="match-h-cat">
                                            ${value.categories?.map(category => `
                                                <div class="tag-badge tag-badge--small">
                                                    ${category}
                                                </div>
                                            `).join('')}
                                        </div>
                                        <div class="date m-0">
                                            ${value.date}
                                        </div>
                                        <h5 class="news-card-detailed__text__title match-h">
                                            ${value.title}
                                        </h5>
                                        <div target="_blank" class="btn btn-primary btn-primary--small news-card-detailed__text__link" >Read more</div>
                                    </div>
                                </div>
                            </div>
                            `
                        );
                        $('.js-futureal-loader').addClass('hide');
                        $('.js-decor').removeClass('hide');
                        $(document).ready(function () {
                            $('.match-h').matchHeight({
                                byRow: true,
                                property: 'height',
                                target: null,
                                remove: false
                            });

                            $('.match-h-cat').matchHeight({
                                byRow: true,
                                property: 'height',
                                target: null,
                                remove: false
                            });
                        });
                    });
                }
            });
        }

    });
})(jQuery);
